import { Select } from "../atoms/Select";
import { events } from "../../constants/events";

export function EventSelect({ value, onChange }) {
  const handleChange = (e) => {
    const id = e.target.value;
    const ev = events.find((x) => x.id === id);

    onChange?.(ev ?? null);
  };

  return (
    <Select value={value} onChange={handleChange}>
      <option value="">選択してください</option>
      {events.map((ev) => (
        <option key={ev.id} value={ev.id}>
          {ev.date} {ev.name}
        </option>
      ))}
    </Select> 
  );
}